import { Menu } from "@headlessui/react";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
import { Icon } from "../icon/Icon";
const DropdownItemIcon = ({ icon, path, }) => {
    if (icon) {
        return (React.createElement("span", { className: "nxm-dropdown-item-icon flex items-center justify-center" }, icon));
    }
    if (path) {
        return React.createElement(Icon, { className: "nxm-dropdown-item-icon", path: path, size: "none" });
    }
    return null;
};
export const DropdownItem = ({ className, children, customContent, leftIcon, leftIconPath, rightIcon, rightIconPath, onClick, ...props }) => (React.createElement(Menu.Item, { ...props }, ({ active, disabled }) => (React.createElement("button", { className: joinClasses(["nxm-dropdown-item", className], {
        "nxm-dropdown-item-active": active,
    }), disabled: disabled, onClick: onClick }, customContent ?? (React.createElement(React.Fragment, null,
    React.createElement(DropdownItemIcon, { icon: leftIcon, path: leftIconPath }),
    !!children && (React.createElement("span", { className: "nxm-dropdown-item-label" }, children)),
    React.createElement(DropdownItemIcon, { icon: rightIcon, path: rightIconPath })))))));
